import "./style.scss";
import { FC } from "react";
import BtnDefault from "../../BtnDefault/BtnDefault";
import VerticalLine from "../../VerticalLine/VerticalLine";
import { applicationPageSvgConst } from "@/src/svg/applicationsPage/applicationsPageSvgExport";
import { useDispatch, useSelector } from "react-redux";
import { toggleColumnVisibility, showAllColumns, hideAllColumns } from "@/src/store/slices/AdmissionOfficeDatabase/AODatabaseTableSlice";
import { RootState } from "@/src/store";
import { setActualUserConfig } from "@/src/store/slices/UserOptions/userOptionsSlice";
import { admissionDatabaseAllFieldsList, normalizeVisibleAODColumns } from "@/src/constants/AdmissionOffice/admissionOfficeDatabaseConsts";
import AODBDocumentActions from "../AODBody/AODBDocumentActions/AODBDocumentActions";
import CustomDescriptionPopUP from "../../CustomUtils/CustomDescriptionPopUP/CustomDescriptionPopUP";

interface IAODHeaderProps {
  isShowSettingsModal: boolean;
  setIsShowSettingsModal: React.Dispatch<React.SetStateAction<boolean>>;
  loadActualData: () => void;
}

const AODHeader: FC<IAODHeaderProps> = ({
  isShowSettingsModal,
  setIsShowSettingsModal,
  loadActualData,
}) => {
  const dispatch = useDispatch();
  const { visibleColumns } = useSelector((state: RootState) => state.AODatabaseTable);
  const aodpFixed = useSelector((state: RootState) => state.userOptions.AODPConfig.AODPFixed);

  const handleSettingsModal = () => {
    setIsShowSettingsModal(!isShowSettingsModal);
    if (isShowSettingsModal) {
      dispatch(
        setActualUserConfig({
          AODPConfig: {
            AODPTable: normalizeVisibleAODColumns(visibleColumns),
            AODPFixed: aodpFixed ?? null,
          },
        }),
      );
    }
  };

  return (
    <div className="admission-database-header">
      <div className="admission-database-header-body">
        <div className="header-actions">
          <AODBDocumentActions loadActualData={loadActualData} />
          <VerticalLine />
          <CustomDescriptionPopUP text="Open table settings and save the current column configuration.">
            <BtnDefault onlyIcon={true} onClick={() => handleSettingsModal()}>
              <applicationPageSvgConst.SettingsSvg />
            </BtnDefault>
          </CustomDescriptionPopUP>
        </div>
      </div>
      <div className={`admission-database-header-settings ${isShowSettingsModal ? "active" : ""}`}>
        <div className="admission-database-header-settings-ul">
          {admissionDatabaseAllFieldsList.map((col) => (
            <div className="admission-database-header-settings-li" key={col.id}>
              <label>
                <input
                  type="checkbox"
                  checked={visibleColumns.some((c) => c.id === col.id)}
                  onChange={() => dispatch(toggleColumnVisibility(col.id))}
                />
                <div className="applications-page-header-settings-li-tab">
                  <applicationPageSvgConst.SettingsTabPlusSvg />
                  <p>{col.title}</p>
                  <applicationPageSvgConst.SettingsTabDeleteSvg />
                </div>
              </label>
            </div>
          ))}
        </div>
        <div className="applications-page-header-settings-buttons">
          <div className="applications-page-header-settings-buttons-both">
            <BtnDefault onClick={() => dispatch(showAllColumns())}>
              <p>Choose all</p>
              <applicationPageSvgConst.ChooseAllSvg />
            </BtnDefault>
            <BtnDefault onClick={() => dispatch(hideAllColumns())}>
              <p>Clear all</p>
              <applicationPageSvgConst.ClearAllSvg />
            </BtnDefault>
          </div>
          <VerticalLine />
          <div className="applications-page-header-settings-buttons-save">
            <BtnDefault reverse={true} onClick={handleSettingsModal}>
              <p>Save</p>
              <applicationPageSvgConst.SaveSvg />
            </BtnDefault>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AODHeader;
